"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Heart = _interopRequireDefault(require("../../icons-react/userflow/Heart"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var WishListButton = function WishListButton(_ref) {
  var onClick = _ref.onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      isHotelCard = _ref.isHotelCard,
      _ref$isSmall = _ref.isSmall,
      isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall;

  var _useState = (0, _react.useState)(isSelected),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isSelectedLocal = _useState2[0],
      setIsSelectedLocal = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsSelectedLocal(isSelected);
  }, [isSelected]);

  var handleClick = function handleClick(e) {
    setIsSelectedLocal(function (selected) {
      return !selected;
    });
    onClick(e);
  };

  return /*#__PURE__*/_react["default"].createElement(StyledWishListButton, {
    onClick: handleClick,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledWishIcon, {
    selected: isSelectedLocal,
    $isHotelCard: isHotelCard,
    isSmall: isSmall,
    $isMobile: isMobile
  }));
};

var StyledWishIcon = (0, _styledComponents["default"])(_Heart["default"]).withConfig({
  displayName: "WishListButton__StyledWishIcon",
  componentId: "sc-uq533w-0"
})(["height:17px;width:20px;cursor:pointer;fill:none;stroke:", ";height:24px;width:24px;cursor:pointer;fill:none;stroke:", ";stroke-width:1;&:hover{", "}", ""], function (_ref2) {
  var isSmall = _ref2.isSmall;
  return isSmall ? '#fff' : '#17181a';
}, function (_ref3) {
  var theme = _ref3.theme,
      $isHotelCard = _ref3.$isHotelCard;
  return $isHotelCard ? "white" : theme.colors.blackBase;
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile,
      theme = _ref4.theme;
  return !$isMobile && "stroke: ".concat(theme.colors.monza, ";");
}, function (_ref5) {
  var selected = _ref5.selected,
      theme = _ref5.theme;
  return selected && (0, _styledComponents.css)(["stroke:none;fill:", ";"], theme.colors.monza);
});

var StyledWishListButton = _styledComponents["default"].div.withConfig({
  displayName: "WishListButton__StyledWishListButton",
  componentId: "sc-uq533w-1"
})(["display:flex;position:relative;align-items:center;justify-content:center;height:24px;width:24px;"]);

var _default = WishListButton;
exports["default"] = _default;